var render = function () {
  var _vm$gift$gifter, _vm$gift$gifter2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap mb-0"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("자동충전")]), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" 선물받은 나누리 캐시를 충전하실 수 있습니다. ")])]), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('v-responsive', {
    staticClass: "mx-auto",
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "width": "100%",
      "max-width": "400"
    }
  }, [false ? void 0 : _vm.mode == 'auth' ? [_c('v-card', {
    staticClass: "py-6 py-lg-12"
  }, [_c('v-card-title', {
    staticClass: "pt-3 pt-lg-6 justify-center"
  }, [_c('span', [_vm._v(" 다른 회원에게 충전된 선물입니다. ")])]), _c('v-card-text', {
    staticClass: "pb-3 pb-lg-6 text-center"
  }, [_c('span', [_vm._v(" 다시 로그인 해주세요. ")])]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', _vm._b({
    staticClass: "w-lg-160px",
    attrs: {
      "large": "",
      "color": "primary",
      "to": "/login"
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 다시 로그인 하기 ")])])], 1)], 1)] : _vm.mode == 'done' ? [_c('v-card', {
    staticClass: "py-6 py-lg-12"
  }, [_c('v-card-text', {
    staticClass: "pt-3 pt-lg-6 text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(((_vm$gift$gifter = _vm.gift.gifter) === null || _vm$gift$gifter === void 0 ? void 0 : _vm$gift$gifter.name) || "홍길동"))]), _vm._v(" 님이 선물하신 나누리 캐시 ")])]), _c('v-card-title', {
    staticClass: "pt-0 pb-3 pb-lg-6 justify-center"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.gift.amount.format()) + "원 ")])]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', _vm._b({
    staticClass: "w-lg-160px",
    attrs: {
      "large": "",
      "outlined": "",
      "color": "primary",
      "to": "/mypage/cashes/inquiry"
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 충전 완료 ")])])], 1)], 1)] : _vm.mode == 'form' ? [_c('v-card', {
    staticClass: "py-6 py-lg-12"
  }, [_c('v-card-text', {
    staticClass: "pt-3 pt-lg-6 text-center"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(((_vm$gift$gifter2 = _vm.gift.gifter) === null || _vm$gift$gifter2 === void 0 ? void 0 : _vm$gift$gifter2.name) || "홍길동"))]), _vm._v(" 님이 선물하신 나누리 캐시 ")])]), _c('v-card-title', {
    staticClass: "pt-0 pb-3 pb-lg-6 justify-center"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.gift.amount.format()) + "원 ")])]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._user ? [_c('v-btn', _vm._b({
    staticClass: "w-lg-160px",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.exec
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 나누리 캐시 충전하기 ")])])] : [_c('v-btn', _vm._b({
    staticClass: "w-lg-160px",
    attrs: {
      "large": "",
      "color": "primary",
      "to": "/login"
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 로그인 후 충전하기 ")])])]], 2)], 1)] : _vm.mode == 'none' ? [_c('v-card', {
    staticClass: "py-6 py-lg-12"
  }, [_c('v-card-title', {
    staticClass: "pt-3 pt-lg-6 justify-center"
  }, [_c('span', [_vm._v(" 취소된 선물입니다. ")])]), _c('v-card-text', {
    staticClass: "pb-3 pb-lg-6 text-center"
  }, [_c('span', [_vm._v(" 자동충전 URL을 다시 확인해주세요. ")])])], 1)] : _vm.mode == 'null' ? [_c('v-card', {
    staticClass: "py-6 py-lg-12"
  }, [_c('v-card-title', {
    staticClass: "pt-3 pt-lg-6 justify-center"
  }, [_c('span', [_vm._v(" 선물 내역을 찾을 수 없습니다. ")])]), _c('v-card-text', {
    staticClass: "pb-3 pb-lg-6 text-center"
  }, [_c('span', [_vm._v(" 자동충전 URL을 다시 확인해주세요. ")])])], 1)] : _vm._e()], 2)], 1)])]), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }